// 出勤用的時間格式。原本住在首頁的打卡小工具裡,那一塊在 2026-09-25 拔掉了
// (業主:「每一個人的打卡模組 都拔除」),出勤紀錄頁與打卡機還要用,所以搬來這裡。

/** 一律用台北時間顯示 —— 伺服器與瀏覽器的時區都可能不是它。 */
export const TAIPEI = "Asia/Taipei";

/** `2026-09-17T01:30:00Z` → `09:30`。認不得就原樣回去,不猜。 */
export function hhmm(iso: string | null | undefined): string {
  if (!iso) return "";
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return String(iso);
  return at.toLocaleTimeString("zh-TW", {
    timeZone: TAIPEI,
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** 台北的今天,`YYYY-MM-DD`。`sv-SE` 給的就是這個格式 —— 比自己組字串少一種錯法。 */
export function taipeiToday(at: Date = new Date()): string {
  return at.toLocaleDateString("sv-SE", { timeZone: TAIPEI });
}
